import React, { useState } from "react";
import { Table, Select, Pagination, Space } from "antd";
import { useQuery } from "react-query";
import { Link, useParams } from 'react-router-dom';
import useAxiosInstance from "../../../lib/useAxiosInstance";
import highPriority from "../../../assets/svg/highPriority.svg"
import mediumPriority from "../../../assets/svg/mediumPriority.svg"
import lowPriority from "../../../assets/svg/lowPriority.svg"
const { Column } = Table;

const Grievances = () => {
  const axiosInstance = useAxiosInstance();
  const { userId } = useParams();
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total] = useState(0);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  //fetch all grievance by assigned to user-->
  const fetchGrievances = async () => {
    return axiosInstance.get(
      `api/userDetails/GrievanceByAssignToUser/${userId}`,
    );
  };
  const grievancesData = useQuery("grievance_By_AssignedToUser", fetchGrievances);
  // <--
  const filteredGmsData = grievancesData?.data?.data?.data.filter(record => record.status !== 'unassigned');
  const pagination = {
    total: total,
    pageSize: limit,
    current: currentPage,
    onChange: handlePageChange,
  };

  function getPriorityIcon(priority) {
    switch (priority) {
      case "high":
        return <img src={highPriority} alt=""/>;
      case "medium":
        return <img src={mediumPriority} alt=""/>;
      case "low":
        return <img src={lowPriority} alt=""/>;
      default:
        return null;
    }
  }

  return (
    <>

      <div className="">
        <div className="gms-table">
          <Table
            className="tms-list"
            rowKey={record => record._id}
            dataSource={filteredGmsData}
            style={{ border: "none !important" }}
            pagination={pagination}

          >
            {/* <Column title="" /> */}
            <Column title="Track Id" dataIndex="_id" className="w-60"/>
            <Column title="Task Name" dataIndex="grievanceTitle"
              render={(text, record) => (
                <Space>
                  {getPriorityIcon(record.priority)}
                  {text}
                </Space>
              )}
            />
            <Column title="Category" dataIndex="categoryName" />
            <Column title="Sub-Category" dataIndex="subCategoryName" />
            <Column title="Due Date" dataIndex="" />
            <Column title="Status" dataIndex="status" />
            <Column title="Action" dataIndex=""
              render={(text, record) => (
                <Space className="view-more-details">
                  <Link to={`/assets-management/user/userInfo/grievanceuserinfo/${record._id}`}><span>View</span></Link>
                </Space>
              )}
            />
          </Table>
        </div>

      </div>
      <div className="client-pagination mr-5">
        <div>
          <Select
            defaultValue={5}
            // value={limit.toString()}
            style={{ width: 56 }}
            // onChange={(value) => setLimit(parseInt(value))}
            options={[
              { value: "10", label: "10" },
              { value: "20", label: "20" },
              { value: "50", label: "50" },
              { value: "100", label: "100" },
            ]}
          />{" "}
          Entries per pages
        </div>
        <div>
          <Pagination
            current={currentPage}
            pageSize={limit}
            total={total}
            onChange={(page, pageSize) => {
              setCurrentPage(page);
              setLimit(pageSize);
            }}
            className="pagination"

          />
        </div>
      </div>

    </>
  )
}

export default Grievances; 